import React from "react";

export const RPGGameCharacterAchievmentStatusIcon = () => {
  return (
    <svg
      width="17"
      height="3"
      viewBox="0 0 17 3"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.208 0.5L16.2695 1.5L15.208 2.5H1.79199L0.729492 1.5L1.79199 0.5H15.208Z"
        stroke="#6A4CD7"
      />
    </svg>
  );
};

